var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "VDialog",
    _vm._b(
      {
        attrs: {
          fullscreen: _vm.fullscreen,
          persistent: _vm.persistent,
          "content-class": _vm.currentVariant.class
            ? _vm.currentVariant.class
            : "",
          width: _vm.width,
          attach: _vm.attach,
          scrollable: _vm.scrollable
        },
        model: {
          value: _vm.dialog,
          callback: function($$v) {
            _vm.dialog = $$v
          },
          expression: "dialog"
        }
      },
      "VDialog",
      _vm.$attrs,
      false
    ),
    [
      _vm.img
        ? _c(
            "VCard",
            { staticClass: "modal__img" },
            [
              _c(
                "VBtn",
                {
                  staticClass: "modal--close",
                  class: { "theme--dark": _vm.small },
                  attrs: { icon: "" },
                  on: { mousedown: _vm.onClose }
                },
                [_c("NsIcon", { attrs: { "icon-name": "icon-close" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "VLayout",
                {
                  class: { wrap: _vm.small },
                  style: { height: !_vm.small ? "300px" : "inherit" }
                },
                [
                  _c("VImg", {
                    attrs: {
                      src: _vm.img,
                      height: _vm.small ? 200 : 300,
                      width: _vm.small ? 300 : 200
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "VFlex",
                    {
                      staticClass: "modal__content",
                      style: { height: _vm.small ? "300px" : "inherit" }
                    },
                    [
                      _vm.title
                        ? _c("VCardTitle", { staticClass: "modal__title" }, [
                            _vm._v(
                              "\n          " + _vm._s(_vm.title) + "\n        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("VCardText", [_vm._t("default")], 2)
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "VCard",
            [
              _c(
                "div",
                { staticClass: "modal__header" },
                [
                  _vm.showIcon
                    ? _c("div", { staticClass: "modal__variant-title" }, [
                        _c(
                          "div",
                          { staticClass: "modal__variant-icon" },
                          [
                            _c("NsIcon", {
                              attrs: {
                                color: _vm.currentVariant.class,
                                "icon-name": _vm.currentVariant.icon
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "modal__variant-text pl-3" }, [
                          _c("div", [_vm._v(_vm._s(_vm.currentVariant.text))])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.title
                    ? _c("VCardTitle", { staticClass: "modal__title" }, [
                        _vm._v("\n        " + _vm._s(_vm.title) + "\n      ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.confirm
                    ? _c(
                        "VBtn",
                        {
                          staticClass: "modal--close",
                          attrs: { icon: "" },
                          on: { mousedown: _vm.onClose }
                        },
                        [
                          _c("NsIcon", { attrs: { "icon-name": "icon-close" } })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "VCardText",
                {
                  style: {
                    height:
                      _vm.scrollable && _vm.contentHeight
                        ? _vm.contentHeight
                        : ""
                  }
                },
                [
                  _c(
                    "VContainer",
                    { attrs: { "grid-list-md": "" } },
                    [_vm._t("default")],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "VCardActions",
                [_vm._t("actions", null, { close: _vm.onClose })],
                2
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }